module.exports = __webpack_public_path__ + "static/img/皮带异物识别.f1ab7b5e.png";